import styled from 'styled-components';

export const DocumentStatusInfoWrapper = styled.div`
    overflow: hidden;
    padding: 1em;
    color: "[theme:bodyText, default: #323130]";
    color: var(--bodyText);

    font-family: 'Segoe UI';

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

export default DocumentStatusInfoWrapper;



